import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvisoLegalComponent } from './pages/aviso-legal/aviso-legal.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ProteccionDatosComponent } from './pages/proteccion-datos/proteccion-datos.component';
import { AccesibilidadComponent } from './pages/accesibilidad/accesibilidad.component';
import { CookiesComponent } from './pages/cookies/cookies.component';



@NgModule({
  declarations: [
    AvisoLegalComponent,
    ProteccionDatosComponent,
    AccesibilidadComponent,
    CookiesComponent,

  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  exports: [

  ]
})
export class LegalModule { }
